import MessagingConfiguration from 'models/messaging_configuration';
import qconsole from 'scripts/lib/qconsole';

export default class MessagingConfigurationGatewayObserver {
  constructor(context) {
    this.context = context;
  }

  get store() {
    return this.context.stores.messagingConfiguration;
  }

  updateStore(dto) {
    this.store.set(MessagingConfiguration.fromJs(dto));
    this.store.resetLoading();
  }

  onBroadcast(dto) {
    if (!this.store.isPending()) {
      this.updateStore(dto);
    }
  }

  onFetchSuccess(dto) {
    this.updateStore(dto);
  }

  onFetchError(error) {
    qconsole.log(`Failed to fetch messaging configuration: ${JSON.stringify(error)}`);
    this.store.resetLoading();
  }

  onBroadcastDelete() {
    if (!this.store.isPending()) {
      this.store.remove();
    }
  }

  onReplaceSuccess() {
    this.store.commitPending();
  }

  onReplaceError(error) {
    qconsole.log(`Failed to replace messaging configuration: ${JSON.stringify(error)}`);
    this.store.resetPending();
  }
}



// WEBPACK FOOTER //
// ./src/scripts/application/actions/configuration/messaging_configuration_gateway_observer.js